import React from 'react';
import { ListProps } from './types';
import { classNames } from './classNames';

import Classes from './ListingOtherSellerList.module.scss';

const List: React.FC<ListProps> = ({ children }) => {
  return <div className={Classes[classNames.listSection]}>{children}</div>;
};

export default List;
